import { configureStore } from "@reduxjs/toolkit";
import authenticationSlice from "./features/Authentication";
import artistSlice from "./features/Artist";
import spotifySlice from "./features/Spotify";
import curatorSlice from "./features/Curator";
import adminArtistsSlice from "./features/AdminArtists";
import adminCampaignSlice from "./features/AdminCampaign";
import adminTeamSlice from "./features/AdminTeam";
import curatorInvitesSlice from "./features/curatorInvites";

export const store = configureStore({
  reducer: {
    authenticationSlice: authenticationSlice,
    spotifySlice: spotifySlice,
    artistSlice: artistSlice,
    curatorSlice: curatorSlice,
    adminArtistsSlice: adminArtistsSlice,
    adminCampaignSlice: adminCampaignSlice,
    adminTeamSlice: adminTeamSlice,
    curatorInvitesSlice: curatorInvitesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
